const ORG_I18N = {
  fr: {
    // Header
    updated:        'Mis à jour',
    refresh:        'Actualiser',
    logout:         'Déconnexion',
    lang_label:     'Langue',

    // Tabs
    tab_overview:      'Aperçu',
    tab_participants:  'Participants',
    tab_agenda:        'Agenda',
    tab_tables:        'Tables',
    tab_requests:      'Demandes',
    tab_codes:         'Codes',

    // Overview
    overview_title:       "Aperçu de l'événement",
    // -- Section Participants
    ov_section_participants: 'Participants & Inscriptions',
    stat_participants:    'Participants',
    stat_checkedin:       'Check-in',
    stat_companies:       'Entreprises',
    stat_accepted_reg:    'Inscriptions acceptées',
    stat_acceptance_rate: "taux d'acceptation",
    stat_free_codes:      'Codes disponibles',
    stat_new_reg:         'Nouvelles inscriptions',
    stat_pending:         'en attente',
    chart_company_types:  "Types d'entreprises",
    chart_no_data:        'Aucune donnée',
    reg_funnel_title:     'Inscriptions',
    top_countries_title:  'Top pays',
    ov_chart_categories:  'Enjeux / Catégories',
    ov_chart_requests:    'Demandes / Offres',
    profile_completion:   'Complétion des profils',
    profile_sub:          (done, total) => `${done} complets / ${total} participants`,
    // -- Section Matchmaking
    ov_section_matchmaking: 'Matchmaking',
    stat_requests:        'Demandes de RDV',
    stat_confirmed:       'RDV confirmés',
    stat_avg_meetings:    'RDV / participant',
    stat_accepted_requests: 'Acceptées',
    stat_rejected_requests: 'Refusées',
    stat_cancelled_requests: 'Annulées',
    slot_occupation:      'Occupation des créneaux',
    slot_sub:             (meetings, slots) => `${meetings} meetings / ${slots} créneaux totaux`,
    // -- Section Networking
    ov_section_networking: 'Networking',
    stat_net_participants: 'Inscrits networking',
    stat_net_connected:    'Connectés',
    stat_net_pending:      'En attente',
    stat_net_declined:     'Refusées',
    stat_net_total:        'Total connexions',

    // Participants tab
    search_participant:  'Rechercher un participant…',
    filter_all:          'Tous',
    filter_complete:     'Complet',
    filter_incomplete:   'Incomplet',
    col_participant:     'Participant',
    col_company:         'Entreprise',
    col_country:         'Pays',
    col_checkin:         'Check-in',
    col_profile:         'Profil',
    profile_ok:          'Complet',
    profile_nok:         'Incomplet',
    no_participants:     'Aucun participant trouvé',
    checkin_btn:         'Check-in',
    checkin_undo:        'Annuler',
    checkin_done:        'Présent',
    checkin_pending:     'Non arrivé',
    checkin_cancelled:   'Annulé',

    // Send agenda by email
    send_agenda_btn:      'Envoyer l\'agenda par email',
    send_agenda_ok:       'Agenda envoyé !',
    send_agenda_error:    'Erreur lors de l\'envoi',
    send_agenda_sending:  'Envoi en cours…',

    // Send agenda to all
    send_all_btn:      'Envoyer Agenda à tous',
    send_all_sending:  'Envoi en cours…',
    send_all_ok:       (n) => `Envoyé à ${n} participants ✓`,
    send_all_error:    'Erreur lors de l\'envoi groupé',
    send_all_confirm:  (n) => `Envoyer l'agenda par email à ${n} participants ?`,

    // Meeting management
    meeting_cancel:          'Annuler le RDV',
    meeting_cancel_error:    "Erreur lors de l'annulation",
    meeting_cancelled_label: 'Annulé',

    // Participant agenda in modal
    modal_agenda:          'Agenda',
    modal_agenda_free:     'Libre',
    modal_agenda_no_slots: 'Aucun créneau disponible',

    // Agenda tab
    search_meeting:  'Rechercher par nom ou entreprise…',
    col_slot:        'Créneau',
    col_table:       'Table',
    col_part_a:      'Participant A',
    col_part_b:      'Participant B',
    col_status:      'Statut',
    no_meetings:     'Aucun meeting trouvé',
    export_excel:    'Export Excel',

    // Tables tab
    tables_title:    "Occupation des tables",
    col_table_h:     'Table',
    no_tables:       'Aucune donnée de table disponible',
    no_tables_sub:   'Les tables apparaîtront une fois des meetings confirmés avec table assignée',

    // Requests tab
    req_all:         (n) => `Tous (${n})`,
    req_filter:      (label, n) => `${label} (${n})`,
    no_requests:     'Aucune demande trouvée',

    // Codes tab
    codes_title:         "Codes d'inscription",
    stat_total_codes:    'Total codes',
    stat_active_codes:   'Actifs',
    stat_uses:           'Utilisations',
    stat_remaining:      'Places restantes',
    search_code:         'Rechercher par code ou entreprise...',
    col_code:            'Code',
    col_status_click:    'Statut (cliquer)',
    col_used_max:        'Utilisé / Max',
    col_used_max_click:  '(cliquer)',
    col_registrants:     'Inscrits',
    no_registrant:       'Aucun inscrit',
    no_codes:            'Aucun code trouvé',
    registrants_title:   'Participants inscrits avec ce code',
    status_active:       'Active',
    status_disabled:     'Désactivé',
    status_new:          'Nouveau',
    tip_disable:         'Cliquer pour désactiver',
    tip_enable:          'Cliquer pour activer',
    save_error:          'Erreur lors de la sauvegarde. Reconnectez-vous si le problème persiste.',

    // Participant modal
    modal_activity:      'Secteur / Activité',
    modal_bio:           'À propos',
    modal_company_info:  'Informations société',
    modal_company_type:  'Type',
    modal_company_activities: 'Secteurs d\'activité',
    modal_company_requests:   'Recherche / Demandes',
    modal_company_website:    'Site web',
    modal_company_address:    'Adresse',
    modal_company_phone:      'Téléphone société',
    modal_company_linkedin:   'LinkedIn société',

    // Edit / Delete participant
    edit_btn:              'Modifier',
    edit_btn_profile:      'Modifier profil',
    edit_btn_company:      'Modifier société',
    edit_save:             'Enregistrer',
    edit_saving:           'Enregistrement…',
    edit_cancel:           'Annuler',
    edit_delete_btn:       'Supprimer',
    edit_delete_confirm:   'Confirmer la suppression de ce participant ?',
    edit_delete_yes:       'Supprimer',
    edit_delete_no:        'Annuler',
    edit_field_name:       'Nom',
    edit_field_job:        'Fonction',
    edit_field_phone:      'Téléphone',
    edit_field_country:    'Pays',
    edit_field_activity:   'Secteur / Activité',
    edit_field_bio:        'À propos',
    edit_field_categories: 'Catégories',
    edit_section_company:  'Entreprise',
    edit_field_company:    "Nom de l'entreprise",
    edit_field_company_desc: 'Description',
    edit_field_comma_hint: 'Séparer par des virgules',

    // Pending validation tab
    tab_pending_validation: 'En attente de validation',
    pv_search:              'Rechercher…',
    pv_filter_all:          'Tous',
    pv_filter_new:          'Nouveau',
    pv_filter_accepted:     'Accepté',
    pv_filter_declined:     'Refusé',
    pv_filter_pending:      'En attente',
    pv_col_name:            'Nom',
    pv_col_company:         'Entreprise',
    pv_col_email:           'Email',
    pv_col_fonction:        'Fonction',
    pv_col_country:         'Pays',
    pv_col_status:          'Statut',
    pv_btn_accepted:        'Accepter',
    pv_btn_declined:        'Refuser',
    pv_btn_pending:         'En attente',
    pv_no_results:          'Aucune inscription trouvée',
    pv_status_new:          'Nouveau',
    pv_status_accepted:     'Accepté',
    pv_status_declined:     'Refusé',
    pv_status_pending:      'En attente',
    pv_save_error:          'Erreur lors de la mise à jour',
    pv_no_free_code:        'Aucun code disponible (plus de codes "Free")',

    // Export participants
    export_participants_btn:      'Export participants Excel',
    export_col_lastname:          'Nom',
    export_col_firstname:         'Prénom',
    export_col_job:               'Fonction',
    export_col_email:             'Email',
    export_col_company:           'Entreprise',
    export_col_phone:             'Téléphone',
    export_col_registered:        "Date d'inscription",
    export_participants_filename: 'participants.csv',

    // Content Management
    tab_content:               'Contenu',
    cm_articles:               'Articles',
    cm_advertising:            'Publicité',
    cm_sponsors:               'Sponsors',
    cm_sponsor_categories:     'Catégories',
    cm_btn_add:                'Ajouter',
    cm_btn_edit:               'Modifier',
    cm_btn_delete:             'Supprimer',
    cm_btn_save:               'Enregistrer',
    cm_btn_cancel:             'Annuler',
    cm_btn_source:             'Source HTML',
    cm_btn_preview:            'Aperçu',
    cm_confirm_delete:         'Confirmer la suppression ?',
    cm_confirm_delete_msg:     'Cette action est irréversible.',
    cm_field_title:            'Titre',
    cm_field_subtitle:         'Sous-titre',
    cm_field_description:      'Description',
    cm_field_status:           'Statut',
    cm_field_position:         'Position',
    cm_field_image:            'Image',
    cm_field_image_upload:     'Choisir un fichier',
    cm_field_image_url:        "URL de l'image actuelle",
    cm_field_type:             'Type',
    cm_field_date:             'Date de publication',
    cm_field_banner_url:       'URL bannière',
    cm_field_video_url:        'URL vidéo (YouTube)',
    cm_field_category:         'Catégorie',
    cm_field_link:             'Lien',
    cm_status_on:              'Visible',
    cm_status_off:             'Masqué',
    cm_no_items:               'Aucun élément. Cliquez sur "Ajouter" pour commencer.',
    cm_saving:                 'Enregistrement…',
    cm_deleting:               'Suppression…',
    cm_error_save:             "Erreur lors de l'enregistrement",
    cm_error_delete:           'Erreur lors de la suppression',
    cm_error_load:             'Erreur lors du chargement',
    cm_col_title:              'Titre',
    cm_col_type:               'Type',
    cm_col_status:             'Statut',
    cm_col_position:           'Position',
    cm_col_category:           'Catégorie',
    cm_col_actions:            'Actions',
    cm_adv_type_sponsor:       'Sponsor',
    cm_adv_type_interstitial:  'Interstitiel',
    cm_sponsors_title:         'Sponsors',
    cm_categories_title:       'Catégories de sponsors',
  },

  de: {
    // Header
    updated:        'Aktualisiert',
    refresh:        'Aktualisieren',
    logout:         'Abmelden',
    lang_label:     'Sprache',

    // Tabs
    tab_overview:      'Übersicht',
    tab_participants:  'Teilnehmer',
    tab_agenda:        'Agenda',
    tab_tables:        'Tische',
    tab_requests:      'Anfragen',
    tab_codes:         'Codes',

    // Overview
    overview_title:       'Veranstaltungsübersicht',
    ov_section_participants: 'Teilnehmer & Anmeldungen',
    stat_participants:    'Teilnehmer',
    stat_checkedin:       'Check-in',
    stat_companies:       'Unternehmen',
    stat_accepted_reg:    'Akzeptierte Anmeldungen',
    stat_acceptance_rate: 'Annahmequote',
    stat_free_codes:      'Verfügbare Codes',
    stat_new_reg:         'Neue Anmeldungen',
    stat_pending:         'ausstehend',
    chart_company_types:  'Unternehmenstypen',
    chart_no_data:        'Keine Daten',
    reg_funnel_title:     'Anmeldungen',
    top_countries_title:  'Top Länder',
    ov_chart_categories:  'Themen / Kategorien',
    ov_chart_requests:    'Anfragen / Angebote',
    profile_completion:   'Profilausfüllung',
    profile_sub:          (done, total) => `${done} vollständig / ${total} Teilnehmer`,
    ov_section_matchmaking: 'Matchmaking',
    stat_requests:        'Meeting-Anfragen',
    stat_confirmed:       'Bestätigte Meetings',
    stat_avg_meetings:    'Meetings / Teilnehmer',
    stat_accepted_requests: 'Akzeptiert',
    stat_rejected_requests: 'Abgelehnt',
    stat_cancelled_requests: 'Storniert',
    slot_occupation:      'Slot-Belegung',
    slot_sub:             (meetings, slots) => `${meetings} Meetings / ${slots} Slots gesamt`,
    ov_section_networking: 'Networking',
    stat_net_participants: 'Networking-Teilnehmer',
    stat_net_connected:    'Verbunden',
    stat_net_pending:      'Ausstehend',
    stat_net_declined:     'Abgelehnt',
    stat_net_total:        'Verbindungen gesamt',

    // Participants tab
    search_participant:  'Teilnehmer suchen…',
    filter_all:          'Alle',
    filter_complete:     'Vollständig',
    filter_incomplete:   'Unvollständig',
    col_participant:     'Teilnehmer',
    col_company:         'Unternehmen',
    col_country:         'Land',
    col_checkin:         'Check-in',
    col_profile:         'Profil',
    profile_ok:          'Vollständig',
    profile_nok:         'Unvollständig',
    checkin_btn:         'Check-in',
    checkin_undo:        'Rückgängig',
    checkin_done:        'Anwesend',
    checkin_pending:     'Nicht angekommen',
    checkin_cancelled:   'Storniert',
    no_participants:     'Keine Teilnehmer gefunden',

    // Send agenda by email
    send_agenda_btn:      'Agenda per E-Mail senden',
    send_agenda_ok:       'Agenda gesendet!',
    send_agenda_error:    'Fehler beim Senden',
    send_agenda_sending:  'Wird gesendet…',

    // Send agenda to all
    send_all_btn:      'Agenda an alle Teilnehmer senden',
    send_all_sending:  'Wird gesendet…',
    send_all_ok:       (n) => `An ${n} Teilnehmer gesendet ✓`,
    send_all_error:    'Fehler beim Massenversand',
    send_all_confirm:  (n) => `Agenda per E-Mail an ${n} Teilnehmer senden?`,

    // Meeting management
    meeting_cancel:          'Meeting absagen',
    meeting_cancel_error:    'Fehler beim Absagen',
    meeting_cancelled_label: 'Abgesagt',

    // Participant agenda in modal
    modal_agenda:          'Agenda',
    modal_agenda_free:     'Frei',
    modal_agenda_no_slots: 'Keine Zeitfenster verfügbar',

    // Agenda tab
    search_meeting:  'Nach Name oder Unternehmen suchen…',
    col_slot:        'Zeitfenster',
    col_table:       'Tisch',
    col_part_a:      'Teilnehmer A',
    col_part_b:      'Teilnehmer B',
    col_status:      'Status',
    export_excel:    'Excel exportieren',
    no_meetings:     'Keine Meetings gefunden',

    // Tables tab
    tables_title:    'Tischbelegung',
    col_table_h:     'Tisch',
    no_tables:       'Noch keine Tischdaten verfügbar',
    no_tables_sub:   'Tische erscheinen, sobald Meetings mit Tischzuweisung bestätigt werden',

    // Requests tab
    req_all:         (n) => `Alle (${n})`,
    req_filter:      (label, n) => `${label} (${n})`,
    no_requests:     'Keine Anfragen gefunden',

    // Codes tab
    codes_title:         'Zugangscodes',
    stat_total_codes:    'Codes gesamt',
    stat_active_codes:   'Aktiv',
    stat_uses:           'Nutzungen',
    stat_remaining:      'Verbleibende Plätze',
    search_code:         'Nach Code oder Unternehmen suchen...',
    col_code:            'Code',
    col_status_click:    'Status (klicken)',
    col_used_max:        'Genutzt / Max',
    col_used_max_click:  '(klicken)',
    col_registrants:     'Angemeldet',
    no_registrant:       'Keine Anmeldungen',
    no_codes:            'Kein Code gefunden',
    registrants_title:   'Mit diesem Code angemeldete Teilnehmer',
    status_active:       'Aktiv',
    status_disabled:     'Deaktiviert',
    status_new:          'Neu',
    tip_disable:         'Klicken zum Deaktivieren',
    tip_enable:          'Klicken zum Aktivieren',
    save_error:          'Fehler beim Speichern. Bitte melden Sie sich erneut an.',

    // Participant modal
    modal_activity:      'Branche / Aktivität',
    modal_bio:           'Über mich',
    modal_company_info:  'Unternehmensinformationen',
    modal_company_type:  'Typ',
    modal_company_activities: 'Aktivitäten',
    modal_company_requests:   'Gesucht / Anfragen',
    modal_company_website:    'Website',
    modal_company_address:    'Adresse',
    modal_company_phone:      'Telefon (Unternehmen)',
    modal_company_linkedin:   'LinkedIn (Unternehmen)',

    // Edit / Delete participant
    edit_btn:              'Bearbeiten',
    edit_btn_profile:      'Profil bearbeiten',
    edit_btn_company:      'Unternehmen bearbeiten',
    edit_save:             'Speichern',
    edit_saving:           'Speichern…',
    edit_cancel:           'Abbrechen',
    edit_delete_btn:       'Löschen',
    edit_delete_confirm:   'Diesen Teilnehmer wirklich löschen?',
    edit_delete_yes:       'Löschen',
    edit_delete_no:        'Abbrechen',
    edit_field_name:       'Name',
    edit_field_job:        'Funktion',
    edit_field_phone:      'Telefon',
    edit_field_country:    'Land',
    edit_field_activity:   'Branche / Aktivität',
    edit_field_bio:        'Über mich',
    edit_field_categories: 'Kategorien',
    edit_section_company:  'Unternehmen',
    edit_field_company:    'Unternehmensname',
    edit_field_company_desc: 'Beschreibung',
    edit_field_comma_hint: 'Durch Komma getrennt',

    // Pending validation tab
    tab_pending_validation: 'Ausstehende Validierung',
    pv_search:              'Suchen…',
    pv_filter_all:          'Alle',
    pv_filter_new:          'Neu',
    pv_filter_accepted:     'Akzeptiert',
    pv_filter_declined:     'Abgelehnt',
    pv_filter_pending:      'Ausstehend',
    pv_col_name:            'Name',
    pv_col_company:         'Unternehmen',
    pv_col_email:           'E-Mail',
    pv_col_fonction:        'Funktion',
    pv_col_country:         'Land',
    pv_col_status:          'Status',
    pv_btn_accepted:        'Akzeptieren',
    pv_btn_declined:        'Ablehnen',
    pv_btn_pending:         'Ausstehend',
    pv_no_results:          'Keine Anmeldungen gefunden',
    pv_status_new:          'Neu',
    pv_status_accepted:     'Akzeptiert',
    pv_status_declined:     'Abgelehnt',
    pv_status_pending:      'Ausstehend',
    pv_save_error:          'Fehler beim Aktualisieren',
    pv_no_free_code:        'Kein Code verfügbar (keine "Free"-Codes mehr)',

    // Export participants
    export_participants_btn:      'Teilnehmer exportieren',
    export_col_lastname:          'Nachname',
    export_col_firstname:         'Vorname',
    export_col_job:               'Funktion',
    export_col_email:             'E-Mail',
    export_col_company:           'Unternehmen',
    export_col_phone:             'Telefon',
    export_col_registered:        'Anmeldedatum',
    export_participants_filename: 'teilnehmer.csv',

    // Content Management
    tab_content:               'Inhalte',
    cm_articles:               'Artikel',
    cm_advertising:            'Werbung',
    cm_sponsors:               'Sponsoren',
    cm_sponsor_categories:     'Kategorien',
    cm_btn_add:                'Hinzufügen',
    cm_btn_edit:               'Bearbeiten',
    cm_btn_delete:             'Löschen',
    cm_btn_save:               'Speichern',
    cm_btn_cancel:             'Abbrechen',
    cm_btn_source:             'HTML-Quelle',
    cm_btn_preview:            'Vorschau',
    cm_confirm_delete:         'Löschen bestätigen?',
    cm_confirm_delete_msg:     'Diese Aktion kann nicht rückgängig gemacht werden.',
    cm_field_title:            'Titel',
    cm_field_subtitle:         'Untertitel',
    cm_field_description:      'Beschreibung',
    cm_field_status:           'Status',
    cm_field_position:         'Position',
    cm_field_image:            'Bild',
    cm_field_image_upload:     'Datei auswählen',
    cm_field_image_url:        'Aktuelle Bild-URL',
    cm_field_type:             'Typ',
    cm_field_date:             'Veröffentlichungsdatum',
    cm_field_banner_url:       'Banner-URL',
    cm_field_video_url:        'Video-URL (YouTube)',
    cm_field_category:         'Kategorie',
    cm_field_link:             'Link',
    cm_status_on:              'Sichtbar',
    cm_status_off:             'Versteckt',
    cm_no_items:               'Keine Einträge. Klicken Sie auf "Hinzufügen".',
    cm_saving:                 'Speichern…',
    cm_deleting:               'Löschen…',
    cm_error_save:             'Fehler beim Speichern',
    cm_error_delete:           'Fehler beim Löschen',
    cm_error_load:             'Fehler beim Laden',
    cm_col_title:              'Titel',
    cm_col_type:               'Typ',
    cm_col_status:             'Status',
    cm_col_position:           'Position',
    cm_col_category:           'Kategorie',
    cm_col_actions:            'Aktionen',
    cm_adv_type_sponsor:       'Sponsor',
    cm_adv_type_interstitial:  'Interstitiell',
    cm_sponsors_title:         'Sponsoren',
    cm_categories_title:       'Sponsor-Kategorien',
  },

  en: {
    // Header
    updated:        'Updated',
    refresh:        'Refresh',
    logout:         'Logout',
    lang_label:     'Language',

    // Tabs
    tab_overview:      'Overview',
    tab_participants:  'Participants',
    tab_agenda:        'Agenda',
    tab_tables:        'Tables',
    tab_requests:      'Requests',
    tab_codes:         'Codes',

    // Overview
    overview_title:       'Event Overview',
    ov_section_participants: 'Participants & Registrations',
    stat_participants:    'Participants',
    stat_checkedin:       'Check-in',
    stat_companies:       'Companies',
    stat_accepted_reg:    'Accepted Registrations',
    stat_acceptance_rate: 'acceptance rate',
    stat_free_codes:      'Available Codes',
    stat_new_reg:         'New Registrations',
    stat_pending:         'pending',
    chart_company_types:  'Company Types',
    chart_no_data:        'No data',
    reg_funnel_title:     'Registrations',
    top_countries_title:  'Top Countries',
    ov_chart_categories:  'Topics / Categories',
    ov_chart_requests:    'Requests / Offers',
    profile_completion:   'Profile Completion',
    profile_sub:          (done, total) => `${done} complete / ${total} participants`,
    ov_section_matchmaking: 'Matchmaking',
    stat_requests:        'Meeting Requests',
    stat_confirmed:       'Confirmed Meetings',
    stat_avg_meetings:    'Meetings / participant',
    stat_accepted_requests: 'Accepted',
    stat_rejected_requests: 'Rejected',
    stat_cancelled_requests: 'Cancelled',
    slot_occupation:      'Slot Occupation',
    slot_sub:             (meetings, slots) => `${meetings} meetings / ${slots} total slots`,
    ov_section_networking: 'Networking',
    stat_net_participants: 'Networking users',
    stat_net_connected:    'Connected',
    stat_net_pending:      'Pending',
    stat_net_declined:     'Declined',
    stat_net_total:        'Total connections',

    // Participants tab
    search_participant:  'Search participant…',
    filter_all:          'All',
    filter_complete:     'Complete',
    filter_incomplete:   'Incomplete',
    col_participant:     'Participant',
    col_company:         'Company',
    col_country:         'Country',
    col_checkin:         'Check-in',
    col_profile:         'Profile',
    profile_ok:          'Complete',
    profile_nok:         'Incomplete',
    no_participants:     'No participants found',
    checkin_btn:         'Check-in',
    checkin_undo:        'Undo',
    checkin_done:        'Present',
    checkin_pending:     'Not arrived',
    checkin_cancelled:   'Cancelled',

    // Send agenda by email
    send_agenda_btn:      'Send agenda by email',
    send_agenda_ok:       'Agenda sent!',
    send_agenda_error:    'Error sending agenda',
    send_agenda_sending:  'Sending…',

    // Send agenda to all
    send_all_btn:      'Send Agenda to all Participants',
    send_all_sending:  'Sending…',
    send_all_ok:       (n) => `Sent to ${n} participants ✓`,
    send_all_error:    'Error during bulk send',
    send_all_confirm:  (n) => `Send agenda by email to ${n} participants?`,

    // Meeting management
    meeting_cancel:          'Cancel Meeting',
    meeting_cancel_error:    'Error cancelling meeting',
    meeting_cancelled_label: 'Cancelled',

    // Participant agenda in modal
    modal_agenda:          'Agenda',
    modal_agenda_free:     'Free',
    modal_agenda_no_slots: 'No slots available',

    // Agenda tab
    search_meeting:  'Search by name or company…',
    col_slot:        'Slot',
    col_table:       'Table',
    col_part_a:      'Participant A',
    col_part_b:      'Participant B',
    col_status:      'Status',
    export_excel:    'Export Excel',
    no_meetings:     'No meetings found',

    // Tables tab
    tables_title:    'Table Occupation',
    col_table_h:     'Table',
    no_tables:       'No table data available yet',
    no_tables_sub:   'Tables will appear once meetings are confirmed with table assignments',

    // Requests tab
    req_all:         (n) => `All (${n})`,
    req_filter:      (label, n) => `${label} (${n})`,
    no_requests:     'No requests found',

    // Codes tab
    codes_title:         'Registration Codes',
    stat_total_codes:    'Total codes',
    stat_active_codes:   'Active',
    stat_uses:           'Uses',
    stat_remaining:      'Remaining spots',
    search_code:         'Search by code or company...',
    col_code:            'Code',
    col_status_click:    'Status (click)',
    col_used_max:        'Used / Max',
    col_used_max_click:  '(click)',
    col_registrants:     'Registrants',
    no_registrant:       'No registrants yet',
    no_codes:            'No codes found',
    registrants_title:   'Participants registered with this code',
    status_active:       'Active',
    status_disabled:     'Disabled',
    status_new:          'New',
    tip_disable:         'Click to disable',
    tip_enable:          'Click to enable',
    save_error:          'Save failed. Please re-login if the problem persists.',

    // Participant modal
    modal_activity:      'Sector / Activity',
    modal_bio:           'About',
    modal_company_info:  'Company Information',
    modal_company_type:  'Type',
    modal_company_activities: 'Activities',
    modal_company_requests:   'What we are looking for',
    modal_company_website:    'Website',
    modal_company_address:    'Address',
    modal_company_phone:      'Company phone',
    modal_company_linkedin:   'Company LinkedIn',

    // Edit / Delete participant
    edit_btn:              'Edit',
    edit_btn_profile:      'Edit profile',
    edit_btn_company:      'Edit company',
    edit_save:             'Save',
    edit_saving:           'Saving…',
    edit_cancel:           'Cancel',
    edit_delete_btn:       'Delete',
    edit_delete_confirm:   'Delete this participant?',
    edit_delete_yes:       'Delete',
    edit_delete_no:        'Cancel',
    edit_field_name:       'Name',
    edit_field_job:        'Role',
    edit_field_phone:      'Phone',
    edit_field_country:    'Country',
    edit_field_activity:   'Sector / Activity',
    edit_field_bio:        'About',
    edit_field_categories: 'Categories',
    edit_section_company:  'Company',
    edit_field_company:    'Company name',
    edit_field_company_desc: 'Description',
    edit_field_comma_hint: 'Comma-separated',

    // Pending validation tab
    tab_pending_validation: 'Pending Validation',
    pv_search:              'Search…',
    pv_filter_all:          'All',
    pv_filter_new:          'New',
    pv_filter_accepted:     'Accepted',
    pv_filter_declined:     'Declined',
    pv_filter_pending:      'Pending',
    pv_col_name:            'Name',
    pv_col_company:         'Company',
    pv_col_email:           'Email',
    pv_col_fonction:        'Role',
    pv_col_country:         'Country',
    pv_col_status:          'Status',
    pv_btn_accepted:        'Accept',
    pv_btn_declined:        'Decline',
    pv_btn_pending:         'Pending',
    pv_no_results:          'No registrations found',
    pv_status_new:          'New',
    pv_status_accepted:     'Accepted',
    pv_status_declined:     'Declined',
    pv_status_pending:      'Pending',
    pv_save_error:          'Update failed',
    pv_no_free_code:        'No code available (no more "Free" codes)',

    // Export participants
    export_participants_btn:      'Export participants Excel',
    export_col_lastname:          'Last Name',
    export_col_firstname:         'First Name',
    export_col_job:               'Role',
    export_col_email:             'Email',
    export_col_company:           'Company',
    export_col_phone:             'Phone',
    export_col_registered:        'Registration Date',
    export_participants_filename: 'participants.csv',

    // Content Management
    tab_content:               'Content',
    cm_articles:               'Articles',
    cm_advertising:            'Advertising',
    cm_sponsors:               'Sponsors',
    cm_sponsor_categories:     'Categories',
    cm_btn_add:                'Add',
    cm_btn_edit:               'Edit',
    cm_btn_delete:             'Delete',
    cm_btn_save:               'Save',
    cm_btn_cancel:             'Cancel',
    cm_btn_source:             'HTML Source',
    cm_btn_preview:            'Preview',
    cm_confirm_delete:         'Confirm deletion?',
    cm_confirm_delete_msg:     'This action cannot be undone.',
    cm_field_title:            'Title',
    cm_field_subtitle:         'Subtitle',
    cm_field_description:      'Description',
    cm_field_status:           'Status',
    cm_field_position:         'Position',
    cm_field_image:            'Image',
    cm_field_image_upload:     'Choose a file',
    cm_field_image_url:        'Current image URL',
    cm_field_type:             'Type',
    cm_field_date:             'Publishing date',
    cm_field_banner_url:       'Banner URL',
    cm_field_video_url:        'Video URL (YouTube)',
    cm_field_category:         'Category',
    cm_field_link:             'Link',
    cm_status_on:              'Visible',
    cm_status_off:             'Hidden',
    cm_no_items:               'No items yet. Click "Add" to get started.',
    cm_saving:                 'Saving…',
    cm_deleting:               'Deleting…',
    cm_error_save:             'Error while saving',
    cm_error_delete:           'Error while deleting',
    cm_error_load:             'Error while loading',
    cm_col_title:              'Title',
    cm_col_type:               'Type',
    cm_col_status:             'Status',
    cm_col_position:           'Position',
    cm_col_category:           'Category',
    cm_col_actions:            'Actions',
    cm_adv_type_sponsor:       'Sponsor',
    cm_adv_type_interstitial:  'Interstitial',
    cm_sponsors_title:         'Sponsors',
    cm_categories_title:       'Sponsor Categories',
  },
};

export const SUPPORTED_LANGS = ['fr', 'de', 'en'];
export const LANG_LABELS = { fr: 'Français', de: 'Deutsch', en: 'English' };

export function getOrgLang() {
  const saved = localStorage.getItem('org_language');
  if (SUPPORTED_LANGS.includes(saved)) return saved;
  const browser = (navigator.language || 'fr').slice(0, 2).toLowerCase();
  return SUPPORTED_LANGS.includes(browser) ? browser : 'fr';
}

export default ORG_I18N;
